

(function ($) {
	// For jQuery 1.4
    $.ajaxSetup({ traditional: true });
    
	// document.ready
    $(function () {
        // logic to determine browser specific CSS class to add to body
        // determine if the browser is Chrome
        var userAgent = navigator.userAgent.toLowerCase();
        $.browser.chrome = /chrome/.test(navigator.userAgent.toLowerCase());

        // which browser specific CSS class to add
        // Must check for chrome before safari because both flags will be true since both are webkit based
        var cls = $.browser.msie ? 'ie ie' + Math.floor($.browser.version) :
				    $.browser.mozilla ? 'ff' :
					$.browser.chrome ? 'chrome' :
                    $.browser.safari ? 'safari' :
                    'other';

        // Add browser specific CSS classes to body
        if (cls != '') {
            $('body').addClass(cls);
        }

        // Set the active page tab
        $('ul.navigation li')
			.addClass('ui-border-left')
			.filter('.left-align:last')
			.addClass('ui-border-right')
			.end()
			.filter('.right-align:first')
			.addClass('ui-border-right')
			.end();
			
        $('body').smoothForm();
        $('.origin-button').originButton();
        $('.origin-buttonset').originButtonset();

        $('.showHelp').originShowHelp();

        // Global enter key handling. This synthesizes a 'focusin' IE proprietary event for the other browsers.
        // The event callback initializes a keydown event when an input field is focused to capture and supress
        // the enterkey as well as trigger a default action as flagged by the CSS class default-action.
        if (!$('.ignore-global-events').length) {
            $(document)
            // Handle when the enter key was pressed inside of an input field.
                .bind('origin-focusin', function (evt, _target) {
                    // We need to normalize our target
                    var target = (_target ? _target : evt.target);
                    if ($(target).data('enterkeybound') !== true) {
                        $(target)
                            .data('enterkeybound', true)
                            .on('keydown', function (evt) {
                                var k = evt.keyCode || evt.which;
                                if (k == 13)
                                    log('Handle Focusin Enter Key');
                                if (k == 13 && $(evt.target).closest('.prevent-default-action').length > 0) {
                                    evt.preventDefault();
                                    if ($(evt.target).is('.prevent-default-action')) {
                                        $(evt.target).trigger('alternateenterkey');
                                        return false;
                                    }
                                    else if ($(evt.target).parents('.prevent-default-action')) {
                                        $(evt.target)
                                        .parents('.prevent-default-action')
                                        .eq(0)
                                        .trigger('alternateenterkey');
                                        return false;
                                    }
                                }
                                if (k == 13 && $(evt.target).is(':not(textarea)')) {
                                    evt.preventDefault();
                                    $(evt.target).trigger('enterkey');
                                    return false;
                                }
                            });
                    }
                })
            // Handle when an input field doesn't have focus and the enter key is pressed (such as when an alert
            // modal was displayed).
                .on('keydown', function (evt) {
                    // This is the fallback keydown handler, if a keydown enter event wasn't handled, we'll check here
                    var k = evt.keyCode || evt.which;
                    if (k == 13)
                        log('Handle Enter Key');
                    if (k == 13 && $(evt.target).closest('.prevent-default-action').length > 0) {
                        evt.preventDefault();
                        if ($(evt.target).is('.prevent-default-action')) {
                            $(evt.target).trigger('alternateenterkey');
                            return false;
                        }
                        else if ($(evt.target).parents('.prevent-default-action')) {
                            $(evt.target)
                                        .parents('.prevent-default-action')
                                        .eq(0)
                                        .trigger('alternateenterkey');
                            return false;
                        }
                    }
                    else if (k == 13 && $(evt.target).is(':not(:input)')) {
                        evt.preventDefault();
                        // Find the last opened dialog and check if it has a default action, if so trigger the click
                        var found = $('div.ui-dialog:last').find('.default-action:eq(0)').click();
                        return !(found.length == 1);
                    }
                    else if (k == 13 && $(evt.target).is(':not(textarea)')) {
                        evt.preventDefault();
                        $(evt.target).trigger('enterkey');
                        return false;
                    }

                    return true;
                })
                .bind('enterkey', function (evt) {
                    var defaultAction = $(evt.target).closest('.contain-enterkey,div.ui-dialog,form,body').find('.default-action:eq(0)');
                    var form = $(evt.target).closest('.contain-enterkey,form');

                    if (defaultAction.length == 1) {
                        defaultAction.click();
                        return false;
                    } else if (form.length == 1) {
                        if (form.is('form') && form.attr('action') != '#') {
                            form.trigger('submit');
                        } else {
                            form.click();
                        }
                        return false;
                    }
                })
                .bind('alternateenterkey', function (evt) {
                    var actionClass = $(evt.target).attr('class');
                    var classArray = actionClass.split(' ');
                    $.each(classArray, function (index, value) {
                        if (value.indexOf('custom-action') != -1) {
                            Origin.doAction(Origin.ConvertDashedToCamel(value));
                        }
                    });
                });
        }
        });

	// This handles the actual action, it is ignorant of what originally triggered the event
	// and reads it's data from the data object
	Origin.onAction('redirect', function (evt, data) {
		Origin.redirect(data.url);
	});

	// This maps and sets up the data object for help
	Origin.actionData('help', function (evt, data) {
		return { url: data.help || $(this).attr('href') };
	});
	// This handles the actual action, it is ignorant of what originally triggered the event
	// and reads it's data from the data object
	Origin.onAction('help', function (evt, data) {
		Origin.showHelp(data.url);
	});

	// Sets up the profile setting data for the saveProfileSetting action
	Origin.actionData('saveProfileSetting', function (evt, data) {
		return {
			module: data.module ? data.module : '',
			key: data.key,
			value: $(this).is(':checked'),
			label: $(this).attr('title') || null
		};
	});
	// This handles any case where a class action-save-profile-setting
	Origin.onAction('saveProfileSetting', function (evt, data) {
		// module, key, value, sync
		Origin.setProfileSetting(data.module, data.key, data.value, function () {
			if (data.label && data.label != '') {
				Origin.notifySuccess(data.label + ' preference saved');
			}
		});
	});

	// INIT: autoinit-city-lookup
	Origin.onInit('cityLookup', function (e, data) {
		// Bind our city lookup event
		$(this).originTypeAheadCity({ url: data.dataUrl });
		// This is needed for firefox as autocomplete=off isn't recognized
		// until you blur and focus the field again
		var _this = this;
		setTimeout(function () {
			$(_this).blur();
			$(_this).focus();
		}, 25);
	});

	// Initialize the history plugin
	$(window)
		.bind('hashchange', function (evt) {
			log('Hash changed');
			var data = {
				hash: $.param.fragment(),
				params: $.bbq.getState()
			};
			// Trigger our event
			$(window).trigger('historychanged', [data]);
			Origin.doAction('historyChanged', data);
		})
		.trigger('hashchange');

	// Listens for click event on any element with "action-submit" class.
	// Submits the form closest to the element. If "data-formid" attribute is provided on the element
	// then the handler submits the form associated with this attribute.
	$('.action-submit').on(Ios_Click, function (evt) {
		var data = $(evt.target).dataset();

		if (data == null || data.formId == null) {
			$(this).closest('form').submit();
		} else {
			$(data.formId).submit();
		}

		evt.preventDefault();
		evt.stopPropagation();
		evt.stopImmediatePropagation();

		return false;
	});


	// TODO: Erase this after all Under Consturction links are replaced with real content
	$('.uc')
		.on('click', function () {
			$('body div#uctooltip').remove();
			$('body .hoverShowing').removeClass('hoverShowing');
			Origin.modal(
			{
				title: "Under Construction",
				content: $('<p>This area is currently under construction.</p>'),
				height: 50,
				width: 300
			});
			return false;
		})
		.on('mouseover', function (e) {
			if (!$(this).hasClass('hoverShowing')) {
				$(this).addClass('hoverShowing');
				$('<div id="uctooltip">Under Construction</div>').css({
					position: 'absolute',
					display: 'none',
					'z-index': '9999',
					top: e.pageY + 5,
					left: e.pageX + 5,
					border: '1px solid #00c',
					padding: '2px 6px',
					'background-color': '#ffb',
					opacity: 0.90,
					'font-weight': 'bold',
					color: '#00c'
				}).appendTo('body').fadeIn(200);
			}
		})
		.on('mouseout', function () {
			$('body div#uctooltip').remove();
			$('body .hoverShowing').removeClass('hoverShowing');
		});
})(jQuery);


